module.exports = __webpack_public_path__ + "img/icon-swap.ce4de633.svg";